import "./uicore-css-color-widget.moduleRenamed.css";

export const colorKeywordSpan = "uicore-css-color-widget-module__colorKeywordSpan___tDNvh";
export const colorBlockSpan = "uicore-css-color-widget-module__colorBlockSpan___3625y";
export const colorSpanActive = "uicore-css-color-widget-module__colorSpanActive___n3TKk";
export const chromeColorPopover = "uicore-css-color-widget-module__chromeColorPopover___tB6FY";

export default {
  colorKeywordSpan: "uicore-css-color-widget-module__colorKeywordSpan___tDNvh",
  colorBlockSpan: "uicore-css-color-widget-module__colorBlockSpan___3625y",
  colorSpanActive: "uicore-css-color-widget-module__colorSpanActive___n3TKk",
  chromeColorPopover: "uicore-css-color-widget-module__chromeColorPopover___tB6FY",
};